import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { OpenInNew } from '@mui/icons-material'
import { IconButton, Stack, Tooltip, Typography } from '@mui/material'

import { Game } from '../../../../../features/game/types/Game'

export const gameSaasPath = (id: string) => `/game/${id}/overview`

export const GameNameCell: FC<{ game: Game }> = ({ game }) => {
  const { t } = useTranslation()
  const label = t('internal-analysts:games_saas_link', { name: game.name })
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography fontWeight="bold">{game.name || '---'}</Typography>
      <Tooltip title={label}>
        <IconButton size="small" href={gameSaasPath(game.id)} target="_blank" rel="noopener noreferrer" aria-label={label}>
          <OpenInNew fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  )
}
